export const environment = {
	production: false,
	API_URL: "https://cdm-api.3cubehealth.com/",
	File_Storage_URL: "https://backend-content-storage.s3.ap-south-1.amazonaws.com/",
	version: "1.0.1"
};